<template>
  <el-dialog title="Adicionar Desconto por Acordo" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="600px" v-loading="loading">
    <el-form ref="form" size="small" :model="desconto" :rules="validacao" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10" style="margin-bottom:20px;">
        <el-col :span="24">

          <el-table
            :data="recibosRecuperados"
            @selection-change="selecaoRecibosHandler"
            empty-text="Nenhum recibo encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row
          >
            <el-table-column type="selection" />
            <el-table-column label="Mês Série" prop="mesSerie" width="100"/>
            <el-table-column label="Início do Período" prop="inicioPeriodo"/>
            <el-table-column label="Fim do Período" prop="fimPeriodo"/>
          </el-table>

        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <h4 style="text-align:center;">Valor do aluguel: {{this.util.formatarValor(aluguel.valor)}}</h4>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="18">
          <el-form-item label="Descrição" prop="descricao">
            <el-input v-model="desconto.descricao"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Valor" prop="valor">
            <money
              v-model="desconto.valor"
              v-bind="money"
              class="el-input__inner"
            />
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>
    <span slot="footer">
      <el-button @click="handleAdicionar" type="primary" size="small" round class="btn-box-shadow">Adicionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import Util from "../../../util/funcoes.js";
import { Money } from "v-money";

export default {
  components:{
    Money
  },
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      recibosRecuperados: [],
      recibosSelecionados: [],
      desconto: {descricao: "" , mesSerie: 0, valor: 0},

      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false
      },
    }
  },
  computed:{
    util() {
      return Util;
    },
    validacao(){
      return {
        descricao: { required: true },
        valor: [{ type: "number", required: true, min: 0.1, max: this.aluguel.valor }],
      }
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapActions('alugueisContratosStore', [
      'recuperarRecibosDescontoPorAcordo',
      'gravarDescontos',
      'gravarDescontosSaldoNegativo',
    ]),

    selecaoRecibosHandler(recibos) {
      this.recibosSelecionados = recibos;
    },

    handleAdicionar() {
      this.$refs["form"].validate(this.handleFormValidation);
    },

    handleFormValidation(isValid) {
      const formIsInvalid = !isValid;
      if(formIsInvalid) {
        this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        return;
      }

      const nenhumMesSerieFoiSelecionado = this.recibosSelecionados.length === 0;
      if(nenhumMesSerieFoiSelecionado) {
        this.exibirAlert("Atenção", "Selecione o mês série");
        return;
      }

      this.adicionar();
    },

    adicionar() {
      const payload = this.montarPayloadGravarDesconto();

      this.showLoading();

      this.gravarDescontos(payload)
        .then(this.handleResultadoGravarDescontos)
        .catch(this.handleRejeicaoGravarDescontos)
        .finally(() => this.hideLoading());
    },

    handleResultadoGravarDescontos(resultado) {
      switch(resultado.status) {
        case 'SUCESSO': {
          const recibosFicaraoComSaldoNegativo = resultado.mensagem.includes('negativo');
          if(recibosFicaraoComSaldoNegativo) {
            this.hideLoading();
            this.confirmarGravacaoDescontosSaldoNegativo(resultado.mensagem);
            return;
          }

          this.$message.success(resultado.mensagem);
          this.fechar();
          break;
        }
        default:
          this.$message.warning(resultado.mensagem);
          break;
      }
    },

    confirmarGravacaoDescontosSaldoNegativo(mensagem) {
      this.$confirm(mensagem, 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Nao',
        type: 'warning'
      }).then(this.handleGravarDescontosSaldoNegativo)
        .catch(() => {});
    },

    handleGravarDescontosSaldoNegativo() {
      const payload = this.montarPayloadGravarDesconto();

      this.showLoading();

      this.gravarDescontosSaldoNegativo(payload)
        .then(this.handleResultadoGravarDescontosSaldoNegativo)
        .catch(this.handleRejeicaoGravarDescontosSaldoNegativo)
        .finally(() => this.hideLoading());
    },

    handleResultadoGravarDescontosSaldoNegativo(resultado) {
      if (resultado.status == 'SUCESSO') {
        this.$message.success(resultado.mensagem);
        this.fechar();
      }
    },

    handleRejeicaoGravarDescontosSaldoNegativo() {
      this.$message.error('Não foi possível conectar-se com o servidor');
    },

    handleRejeicaoGravarDescontos() {
      this.$message.error('Não foi possível conectar-se com o servidor');
    },

    montarPayloadGravarDesconto() {
      return {
        id: this.aluguel.id,
        descontos: this.montarDescontos(),
      };
    },

    montarDescontos() {
      const descontos = [...this.aluguel.descontos];

      this.recibosSelecionados.forEach(({ mesSerie }) => {
        const desconto = {
          ...this.desconto,
          mesSerie,
        };
        descontos.push(desconto);
      });

      return descontos;
    },

    iniciar() {
      let payload = {
        id: this.aluguel.id,
      }

      this.showLoading();
      this.recuperarRecibosDescontoPorAcordo(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.recibosRecuperados = resultado.lista;
            break;
          default:
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    reset(){
      this.recibosRecuperados = []
      this.recibosSelecionados = []
      this.desconto = { descricao: "" , mesSerie: 0, valor: 0 }
    },
    fechar() {
      this.reset()
      this.$emit('close');
    }, 
  }
}
</script>
